import { AppQueryParams } from '../../constants/queryParams';

/**
 * クエリパラメータをもとに求人一覧用のpreBtnを作成する
 * @param {AppQueryParams} queryParams そのページのクエリパラメータ
 * @returns preBntが追加されたクエリパラメータ
 */
export const createPreBtn = (queryParams: AppQueryParams) => {
  const appQueryParams: AppQueryParams = { ...queryParams };
  if (queryParams.ar || queryParams.pr || queryParams.ci) {
    appQueryParams.preBtn = '1';
  } else if (queryParams.ind) {
    appQueryParams.preBtn = '2';
  } else if (queryParams.oc) {
    appQueryParams.preBtn = '3';
  } else {
    appQueryParams.preBtn = undefined;
  }
  return appQueryParams;
};
